export default [
  {
    value: 'id',
    locale: 'objects.ID',
    width: '50px',
  },
  {
    value: 'name',
    locale: 'objects.name',
  },
  {
    value: 'accounts',
    locale: 'objects.routing.chatGateways.messenger.accounts',
  },
  {
    value: 'subscription',
    locale: 'objects.routing.chatGateways.messenger.facebook.subscription',
  },
];
